import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../theme';
import { NASProductCategory } from '@websky/graphql';
import { GdsAggregationServiceGroup } from '../../../../Checkout/types';
import { getNasServiceCardParams } from '../utils';
import WrappedCommonCard from '../CommonCard/WrappedCommonCard';

interface Props {
	segmentId?: string;
	service: GdsAggregationServiceGroup;
}

const Vip: React.FC<Props> = ({ service, segmentId }) => {
	const { t } = useTranslation('Checkout');
	const { t: aasT } = useTranslation('ServiceAggregation');
	const theme = useTheme('CheckoutAdditionalService').Vip;

	const params = getNasServiceCardParams(NASProductCategory.vip);

	return (
		<WrappedCommonCard
			segmentId={segmentId}
			category={NASProductCategory.vip}
			header={t(params.title)}
			service={service}
			description={t(params.description)}
			coverClassName={theme.vip}
			icons={params.icons}
		>
			{aasT('Entrance with boarding ticket')}
		</WrappedCommonCard>
	);
};

export default Vip;
